export default __webpack_public_path__ + "static/docent_office-1-bf5202ed47d5f4dc565eb789a217e572.jpg";